import React from "react";
import { Download } from "lucide-react";
import { PageHead } from "../components/PageHead";
import { DataTable } from "../components/DataTable";
import { Badge } from "../components/Badges";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";

export default function MyCertificates() {
  const columns = [
    { key: "certificate_number", label: "Cert. no.", sortable: true, mono: true, render: (v) => <span className="t-strong mono">{v}</span> },
    { key: "description", label: "Equipment", sortable: true, render: (v) => <span className="t-mut">{v || "—"}</span> },
    { key: "calibration_date", label: "Cal. date", sortable: true, mono: true, render: (v) => <span className="t-mut">{fmtDate(v)}</span> },
    { key: "calibration_due_date", label: "Due date", sortable: true, mono: true, render: (v) => <span className="t-mut">{fmtDate(v)}</span> },
    { key: "status", label: "Status", sortable: true, render: (v) => v === "reissued" ? <Badge label="Reissued" cls="b-violet" /> : <Badge label="Issued" cls="b-green" /> },
    { key: "id", label: "", render: () => <button className="btn sm ghost" onClick={() => toast.info("Certificate PDF export arrives in Phase 3 (template-based generation).")}><Download size={13} /> PDF</button> },
  ];
  return (
    <>
      <PageHead crumb="My Account" title="Certificates"
        sub="Download your issued calibration certificates — sortable & searchable." />
      <DataTable endpoint="/certificates" columns={columns} rowKey="id" testid="my-certs"
        defaultSort={{ by: "created_at", dir: "desc" }} searchPlaceholder="Search certificate, equipment…" />
    </>
  );
}
